import { useEffect, useRef } from 'react';
import {
  NativeDialogBase,
  type NativeDialogBaseProps,
} from './NativeDialogBase';

// This component follows current Ramen Modal pattern of passing isOpen and onDismiss as props. Alternatively, <NativeDialog /> can be used if it's possible to call dialog.showModal and dialog.close directly from the caller. See storybook for examples.

type NativeDialogWrapperProps = NativeDialogBaseProps & {
  isOpen: boolean;
  onDismiss: () => void;
  containerClassName?: string;
};

export function NativeDialogWrapper(props: NativeDialogWrapperProps) {
  const { isOpen, onDismiss } = props;

  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (isOpen) {
      ref.current.showModal();
    } else {
      ref.current.close();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const dialog = ref.current;

    const onModalClose = () => onDismiss();
    dialog.addEventListener('close', onModalClose);

    return () => dialog.removeEventListener('close', onModalClose);
  }, [onDismiss]);

  return <NativeDialogBase {...props} dialogRef={ref} />;
}
